module.exports = __webpack_public_path__ + "img/step-1.e9b0f21.jpg";